import { ID, TaskCalendarOverride } from '@griply/types';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type SetTaskCalendarOverrideOptions<
  TDocRef = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  connectionId: ID;
  taskId: ID;
  // The full desired override for this task on this connection, or null to
  // remove the entry entirely (task falls back to the linked-item defaults).
  override: TaskCalendarOverride | null;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  updateDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void>;
  db: TDb;
  serverTimestamp: () => TFieldValue;
  deleteField: () => TFieldValue;
  onWriteError: (error: unknown) => void;
};

export const setTaskCalendarOverride = <
  TDocRef,
  TFieldValue,
  TDb = FirestoreInstance,
>(
  options: SetTaskCalendarOverrideOptions<TDocRef, TFieldValue, TDb>,
): void => {
  const {
    connectionId,
    taskId,
    override,
    doc,
    updateDoc,
    db,
    serverTimestamp,
    deleteField,
    onWriteError,
  } = options;

  const ref = doc(db, FirestoreCollections.ExternalConnections, connectionId);

  detachWrite(
    updateDoc(ref, {
      [`settings.taskOverrides.${taskId}`]:
        override === null ? deleteField() : override,
      updatedAt: serverTimestamp(),
    }),
    onWriteError,
  );
};
